import { render, staticRenderFns } from "./hiring.vue?vue&type=template&id=deba584e&"
import script from "./hiring.vue?vue&type=script&lang=js&"
export * from "./hiring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports